import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import Paper from "@mui/material/Paper";
import _ from "lodash";
import {
  BootstrapTooltip,
  context_styles
} from "../mi_styles";
import "../mi.css";
import axios from "axios";
import { styled } from '@mui/material/styles';
import { Tag } from 'antd';
import { makeStyles } from '@mui/styles';
import { Chip } from '@mui/material';
import moment from "moment";
import { useSpring, animated } from '@react-spring/web';
import { useSelector, useDispatch } from "react-redux";
import { Projects } from "../miComponents/projects";
import { StyledAutocompleteDark } from "../miComponents/styled_autocomplete";
import { StyledDatePicker } from "../miComponents/styledDatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import TextField from "@mui/material/TextField";
import { miImageActions } from "../../store/store";
import VisualizeAudits from "./modes/visualizeAudits";
import AuditSearch from "./modes/auditSearch";

const colors = [
  'magenta',
  'red',
  'volcano',
  'orange',
  'gold',
  'lime',
  'green',
  'cyan',
  'blue',
  'geekblue',
  'purple',
];

export default function Default(props) {
  const {
    color,
    col_100
  } = useSelector(state => state.miStore);
  const [date, setDate] = useState(null);
  const [filters, setFilters] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [imageData, setImageData] = useState([]);
  const [tags, setTags] = useState({
    'AI answer': true,
    'HI answer': true,
    'Disable Boxes': true
  });

  const StyledChip = styled(Chip)(({ theme }) => ({
    backgroundColor: col_100,
    color: "rgba(245, 245, 245, 0.75)"
  }));

  const useAutoCompleteStyles = makeStyles({
    option: {
      fontSize: '0.875rem',
    },
  });
  const dispatch = useDispatch();
  const autocomplete_classes = useAutoCompleteStyles();

  const [springs, api] = useSpring(() => ({
    from: {
      y: 0
    },
    config: {
      mass: 7,
    }
  }))

  useEffect(() => {
    api.start({
      from: {
        opacity: 0,
        y: -15 + "%"
      },
      to: {
        opacity: 1,
        y: 0 + "%"
      }
    })
  }, [])


 
  return (
    <animated.div style={{ ...springs }}>
      {/* <VisualizeAudits /> */}
      <AuditSearch />
    </animated.div>
  )
}